import React from 'react'
import Header from '../Components/Header'
import useUser from '../hooks/useUser'
import WriteLog from '../Components/Globals/WriteLog'
import Login from '../Components/Login/Login'
import { useNavigate, useParams } from 'react-router-dom'
import Home from '../Components/Home/Home'
import Dashboard from '../Components/Dashboard'

function DashboardPage(){
     
    const {id} = useParams();
    WriteLog("HomePage->status", id)
    const {user, setUser} = useUser();           
    
    const navigate = useNavigate();
    
    if(!user) {
        navigate("/login")        
    }
        
    return (      
        <div>
            <Header routing={"/"}></Header>    
            <div className='flex'>                
                <Dashboard/>
            </div>              
        </div>          
    )
}

export default DashboardPage